import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { Hospital as HospitalImp } from '@/types/core'
import Apis from '@/Apis/_'
import moment from 'moment'
import { PropriedadeFinxEnum, PropriedadeHisEnum } from '@/types/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  hospital: boolean,
  editarHospital: boolean,
  deFinxParaHis: boolean,
  hospitalLogo: boolean,
}

type Endereco = {
  logradouro: string,
  numero: string
  complemento: string,
  cep: string,
  bairro: string,
  cidade: string,
  uf: string,
  dataCadastro?: string,
}

type TipoDeCliente = 'Hospital' | 'Clinica'
type Histipo = 'Finx' | 'Tasy' | 'MV' | 'SisHosp' | 'Lucedata'

enum ContextoBancoDeDados {
  FinxAgendamentoContext = 'FinxAgendamentoContext',
  FinxAgendamentoUhgContext = 'FinxAgendamentoUhgContext',
  FinxAgendamentoDasaContext = 'FinxAgendamentoDasaContext',
}

interface NovoHospital {
  novoHospitalId: string,
  razaoSocial: string
  nomeFantasia: string,
  cnpj: string,
  cnes: string,
  endereco: Endereco,
  // enderecos: EnderecoHospitalCadastro[],
  logo: string,
  hisTipo: Histipo
  tipoDeCliente?: TipoDeCliente,
  hospitalModeloId: string,
  contextoDB: ContextoBancoDeDados,
  email: string,
  emailAgendamento: string,
  emailSuprimentos: string,
  emailRespostaSuprimentos: string,
  emailMapaCirurgico: string,
  emailOrcamento: string,
  nomeGrupo: string,
}

// interface TemplateMapaCirurgicoEtapa {
//   agendamento: boolean,
//   autorizacao: boolean,
//   suprimentos: boolean,
//   farmacia: boolean,
//   centroCirurgico: boolean,
//   centralDeMateriaisEspeciais: boolean,
//   engenhariaClinica: boolean,
//   preInternacao: boolean,
//   opme: boolean,
//   hotelaria: boolean,
//   anestesia: boolean,
//   gerenciamentoLeito: boolean,
//   bancoDeSangue: boolean,
//   tesouraria: boolean,
// }

interface HospitalConfigFlag {
  id: string,
  tipoDeCliente: string,
  nome: string,
  cnpj?: string | null,
  // templateMapaCirurgicoEtapa: TemplateMapaCirurgicoEtapa,
  fazReservaDeSala: boolean,
  hisTipo: Histipo,
  hospitalInsereProcedimentosDeInternacao: boolean,
  hospitalUtilizaRegraDeMedicoExecutante: boolean,
  hospitalUtilizaChat: boolean,
  hospitalSolicitaAlterarReservaNoMapaCirurgico: boolean,
  hospitalEnviaEmailParaOPacienteNaTriagem: boolean,
  exigeNumeroReserva: boolean,
  listaApenasFornecedorHomologadoParaOBackoffice: boolean,
  exibeAlertaDeFornecedorNaoHomologado: boolean,
  hospiltaTemConfiguracaoPdf: boolean,
  dataGoLiveIntegracaoHis: Date | string | null,
  hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada: boolean,
  hospitalAutorizaSolicitacaoNaTriagemQuandoInformadoSenhaProvisoria: boolean,
  hospitalUtilizaFluxoDeRevisaoCirurgicaDeCirurgiaParticular: boolean,
  hospitalIncluiEquipamentoExigidoNoProcedimentoNoMedicoFinalizar: boolean,
  hospitalPreencheNumeroDaReserva: boolean,
  informaMotivoTransferenciaReserva: boolean,
  utilizarCaixaDeSaidaTemporaria: boolean,
  resolvePendenciaDeMedico: boolean,
  exibeOpmeDeHospitalParaOMedico: boolean,
  exibeFornecedorDeHospitalParaOMedico: boolean,
  diasParaTriagemPrioritaria: number | null,
  hospitalIncluiSolicitacaoParaMedicoSemLogin: boolean,
  permiteDesfazerCancelamento: boolean,
  dataAutorizacaoNaOperadoraObrigatoria: boolean,
  dataAutorizacaoNaOperadoraEditavel: boolean,
  utilizaExibicaoDeComentarioSimplificado: boolean,
  hospitalUtilizaCategoriaPorPlano: boolean,
  hospitalFazOrcamentoParticularAvulso: boolean,
  hospitalEnviaAguardandoAutorizacaoUrgenciaDepoisDaAnalisePreAutorizacaoUrgencia: boolean,
  hospitalEnviaAnalisePreAutorizacaoUrgenciaDepoisDaTriagem: boolean,
  nomeRede: string | null,
  tipoCotacaoOpmeNoHis: string | null,
  integradorServiceEndpointKey: string | null,
  preencheNumeroDaReserva: string | null,
  diasParaBloqueioDeAlteracaoDeDataAntesDaCirurgia: number | null,

  enviaEmailPreReserva: boolean,
  enviaSmsDeStatusDaAutorizacaoParaOPaciente: boolean,
  hospitalFazOrcamento: boolean,
  hospitalFazCotacaoDeOpmeAposTriagem: boolean,
  hospitalFazPreAgendamento: boolean,
  hospitalNotificaCirurgiaAutorizada: boolean,
  hospitalNotificaCirurgiaAutorizadaParcial: boolean,
  hospitalNotificaOrcamentoDeCirurgiaParticular: boolean,
  hospitalRealizaTriagemDuranteOPreAgendamento: boolean,
  hospitalTemFluxoDeEntradaDeSolicitacaoPorTipoDeUsuarioQueEnviou: boolean,
  hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos: boolean,
  hospitalAplicaRegraValorAcimaDoLimiteDoPacote: boolean,
  hospitalFazAnalisePosCotacao: boolean,
  hospitalFazDeParaDeCodificacaoDeOpme: boolean,
  hospitalFazPreAutorizacaoDepoisDeFazerAnalisePosCotacao: boolean,
  hospitalEnviaParaSuprimentosAposTriagem: boolean,
  hospitalUtilizaFluxoDePrecificacaoOperadora: boolean,
  hospitalUtilizaStatusRetornoDeCotacao: boolean,
  hospitalFazPreAutorizacaoDepoisDePreCotacao: boolean,
  hospitalUsaAreaDeSuprimentosMesmoSemCotarOpme: boolean,
  hospitalFazPreAutorizacaoDepoisDeFazerCotacao: boolean,
  hospitalBloqueiaReservaQuandoTemConflitoDeEquipamentos: boolean,
  hospitalAnexaImagensNoEmailDeNovaSolicitacao: boolean,
  hospitalUtilizaFluxoDeReservaDeMaterial: boolean,
  dataVirtualFazReservaDeSala: boolean,
  recomecaFluxoDaSolicitacaoAoDesfazerCancelamento: boolean,
  hospitalFazAnalisePreCotacaoNaUrgencia: boolean,
  enviaNotificacoes: boolean,
  enviaEmailDeDataConfirmadaParaOMedico: boolean,
  enviaEmailDeStatusDaAutorizacaoParaOMedico: boolean,
  enviaSMSDeStatusDaAutorizacaoParaOMedico: boolean,
  enviaSMSDeDataConfirmadaParaOMedico: boolean,
  enviaSMSDeDataConfirmadaParaOPaciente: boolean,
  hospitalNotificaProximasCirurgiasConfirmadas: boolean,
  hospitalEnviaParaSuprimentosAposTriagemNaUrgencia: boolean,
  desfazerCancelamentoComOpmeVoltaParaAntesDeSuprimentos: boolean,
  usaProcedimentoApenasHospitalDia: boolean,
  bloqueiaEdicaoDaPendenciaEmAutorizacao: boolean,
  hospitalConfiguraSalaCentroCirurgico: boolean,
  permiteCancelarCirurgiaRealizada: boolean,
  hospitalEvoluiParaAutorizadaPosAnalisePreAutorizacao: boolean,
  hospitalFazAnalisePreAutorizacaoAposTriagem: boolean,
  hospitalNaoPermiteOpcoesDatasSugeridasNoMesmoDia: boolean,
  hospitalEnviaParticularParaAguardandoNegociacao: boolean,
  hospitalEnviaParticularParaOHisNaTriagem: boolean,
  hospitalEnviaParticularParaOrcamentoNaRevisaoCirurgica: boolean,
  hospitalFazReservaDeSalaEmHospitalDaRede: boolean,
  hospitalEnviaParticularParaOrcamentoNaTriagem: boolean,
  hospitalExigeDocumentacaoDoPacienteQuandoCaraterUrgencia: boolean,
  hospitalPermiteAlterarMedicoSolicitante: boolean,
  particularVaiParaAutorizadoAposTriagem: boolean,
  utilizaTipoAcomodacaoHospital: boolean,
  hospitalMantemSituacaoAoAlterarCarater: boolean,
  fidelizacaoBloqueiaPreCotacao: boolean,
  hospitalEnviaAlteracaoParaOHisComCirurgiaRealizada: boolean,
  hospitalBloqueiaAlteracaoDeReservaComCirurgiaRealizada: boolean,
  usaAntecedenciaNaVigenciaDaConfiguracaoDeSala: boolean,
  maximoDiasMedicoSemReserva: number | null,
  usaFluxoDeFarmacia: boolean,
  hospitalIntegraComAutorizadorAntesDaReserva: boolean,
  hospitalCancelaNaFinxMesmoComErroDeCancelamentoNoHis: boolean,
  hospitalPossuiTermoDeUso: boolean,
  hospitalUtilizaRegrasDeReservaDeSala: boolean,
  hospitalIntegraPais: boolean,
  hospitalInformaPacienteInternado: boolean,
  usaAnalisePreAutorizacaoNaUrgenciaComOpmeComCotacao: boolean,
  usaAnalisePreAutorizacaoNaUrgenciaComOpmeSemCotacao: boolean,
  usaAnalisePreAutorizacaoNaUrgenciaSemOpme: boolean,
  enviaParaAutorizacaoPosNaUrgencia: boolean,
  urgenciaNaTriagemEnviaParaRevisaoCirurgica: boolean,
  urgenciaParticularNaTriagemEnviaParaRevisaoCirurgica: boolean,
  usaAnalisePreAutorizacaoNaUrgenciaParticularSemOpme: boolean,
  usaAnalisePreAutorizacaoNaUrgenciaParticularComOpmeSemCotacao: boolean,
  usaAnalisePreAutorizacaoNaUrgenciaParticularComOpmeComCotacao: boolean,
  enviaParaAutorizacaoPosNaUrgenciaParticular: boolean,
  hospitalExibeCancelamentoSolicitadoNoMapaGradeCirurgica: boolean,
  iniciaFluxoDoPreAnestesicoNoMedicoFinaliza: boolean,
  tempoCirurgicoParametrizadoPadrao: null | number,
  hospitalInformaMotivoDeRecusaDoOrcamento: boolean,
  convenioPrazoEmDiasParaTriagem: null | number,
  hospitalIntegradoEnviaNovaSolicitacaoParticularParaOrcamentoAposTriagem: boolean,
  hospitalGeraGuiaTissPeloFront: boolean,
  hospitalFazOrcamentoAntesDoAgendamento: boolean,
  hospitalUtilizaControleDePagamentoParaOrcamentoParticular: boolean,
  hospitalBloqueiaEdicaoAposOrcamentoAprovado: boolean,
  hospitalBloqueiaConvenioNaoParticularNaPendenciaDeOrcamento: boolean,
  gravaPrimeiroIdEquipamentoAoEscolherGrupoEquipamento: boolean,
  hospitalFazRevisaoCirurgicaNaAutorizacao: boolean,
  hospitalPermitePreInternacaoEmQualquerEtapaDoBateMapa: boolean,
  hospitalConfiguraDataSugeridaEmDiasUteis: boolean,
  hospitalRemoveParticularDaGuiaTiss: boolean,
  rotuloFornecedorGuiaTiss: string,
  hospitalAlteraStatusAoCriarSolicitacaoDoAutorizador : boolean,
  hospitalValidaHisIdDoFornecedorOpme: boolean,
  realizaVerificacaoAutomaticaElegibilidade: boolean,
  horariosConsultaElegibilidadeAutomatica: number[] | null,
  hospitalUtilizaCategoriaConvenioComoFallback: boolean,
  hospitalOcultaAprovacaoParaMedicoESecretaria: boolean,
  hospitalOfertaProcedimentosViaNegociacaoComConvenio: boolean,
  permiteVisualizacaoGuiaTissNaVisaoClinica: boolean,
  hospitalAutorizaAposAprovacaoDoOrcamento: boolean,
  hospitalUtilizaFluxoPreCotacao: boolean,
  hospitalNaoAvancaNaAutorizacaoEmAnalise: boolean,
}

export interface DeFinxParaHis {
  id?: string,
  propriedadeFinx: string,
  propriedadeHis: string,
  valorFinx: string,
  valorHis: string,
  hisTipo?: Histipo,
  hospitalId?: string,
}


@Module({ namespaced: true, name: 'SuporteHospitaisStore' })
export default class SuporteHospitaisStore extends VuexModule {
  public modal: SuporteModal = {
    hospital: false,
    editarHospital: false,
    deFinxParaHis: false,
    hospitalLogo: false,
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  /** Hospital selecionado para upload de logo (abertura do modal). */
  public hospitalLogoItem: { hospitalId: string, nome: string } | null = null

  /** Logo do hospital em base64 (preenchida ao buscar antes de abrir o modal). */
  public currentHospitalLogo: string | null = null

  @Mutation
  setHospitalLogoItem(value: { hospitalId: string, nome: string } | null) {
    this.hospitalLogoItem = value
  }

  @Mutation
  setCurrentHospitalLogo(value: string | null) {
    this.currentHospitalLogo = value
  }

  @Mutation
  clearHospitalLogoItem() {
    this.hospitalLogoItem = null
    this.currentHospitalLogo = null
  }

  @Action
  async getHospitalLogo(hospitalId: string) {
    try {
      this.setCurrentHospitalLogo(null)
      const request = await Apis.Agendamento.SuporteApi.getHospitalLogo(hospitalId)
      if (request && request.success && request.data) {
        const base64 = typeof request.data === 'string' ? request.data : (request.data.logo || request.data.data)
        if (base64) this.setCurrentHospitalLogo(base64)
      }
      return request
    } catch (error) {
      this.setCurrentHospitalLogo(null)
      return { success: false, data: null }
    }
  }

  @Action
  async uploadHospitalLogo(logoBase64: string) {
    try {
      if (!this.hospitalLogoItem || !this.hospitalLogoItem.hospitalId) {
        return { success: false, message: 'Hospital não selecionado.' }
      }
      const request = await Apis.Agendamento.SuporteApi.uploadHospitalLogo(
        this.hospitalLogoItem.hospitalId,
        logoBase64,
      )
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  public mode: Mode = 'CREATE'
  public hospitais: any[] = []
  public hospital: HospitalImp.IHospital = new HospitalImp.Hospital()

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  @Mutation
  setHospitais(values: any[]) {
    this.hospitais = values
  }

  @Action
  async getHospitalAll() {
    const response = await Apis.Agendamento.SuporteApi.getAllHospitalSuporteConfiguracao()
    if (response.success) {
      this.context.commit('setHospitais', response.data)
    }
    return response
  }

  @Action
  async getHospitalById(id: string) {
    const response = await this.hospital.getHospitalCompletoById(id)
    if (response.success) this.context.commit('setHospital', response.data)
    return response
  }

  /** NOVO HOSPITAL */
  private novoHospitalDefault: NovoHospital = {
    novoHospitalId: '',
    razaoSocial: '',
    nomeFantasia: '',
    cnpj: '',
    cnes: '',
    // enderecos: [],
    endereco: {
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      cep: '',
      uf: '',
      dataCadastro: new Date().toISOString(),
    },
    logo: '',
    hisTipo: 'Finx',
    tipoDeCliente: 'Hospital',
    hospitalModeloId: '',
    contextoDB: ContextoBancoDeDados.FinxAgendamentoContext,
    email: '',
    emailAgendamento: '',
    emailSuprimentos: '',
    emailRespostaSuprimentos: '',
    emailMapaCirurgico: '',
    emailOrcamento: '',
    nomeGrupo: '',
  }

  public novoHospital: NovoHospital = { ...this.novoHospitalDefault }
  public listaDeHospitais: Array<{ id: string, nome: string}> = []

  @Mutation
  clearNovoHospital() {
    this.novoHospital = { ...this.novoHospitalDefault }
  }

  @Mutation
  clearListaDeHospitais() {
    this.listaDeHospitais = []
  }

  @Mutation
  setListaDeHospitais(value: Array<{ id: string, nome: string}>) {
    this.listaDeHospitais = value
  }

  @Mutation
  updateEndereco(value: any) {
    this.novoHospital.endereco.logradouro = value.logradouro || ''
    this.novoHospital.endereco.complemento = value.complemento || ''
    this.novoHospital.endereco.bairro = value.bairro || ''
    this.novoHospital.endereco.cidade = value.localidade || ''
    this.novoHospital.endereco.uf = value.uf || ''
  }

  @Action
  async buscaCep() {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.buscaCep(this.novoHospital.endereco.cep)
      if (!request.erro) this.context.commit('updateEndereco', request || {})
      return request
    } catch (error) {
      this.context.commit('updateEndereco', {})
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getListaDeHospitais() {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllHospital()
      if (request.success) this.context.commit('setListaDeHospitais', request.data.map((hospital: any) => ({ id: hospital.id, nome: hospital.nome })))
      return request
    } catch (error) {
      this.context.commit('setListaDeHospitais', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async criarHospitalUtilizandoModelo() {
    try {
      const params: any = { ...this.novoHospital }

      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', null, undefined].includes(value)) delete params[key]
      })

      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.criarHospitalUtilizandoModelo(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** HOSPITAL PARA EDIÇÃO */
  private hospitalConfigFlagDefault: HospitalConfigFlag = {
    id: '',
    tipoDeCliente: '',
    nome: '',
    cnpj: '',
    // templateMapaCirurgicoEtapa: {
    //   agendamento: false,
    //   autorizacao: false,
    //   suprimentos: false,
    //   farmacia: false,
    //   centroCirurgico: false,
    //   centralDeMateriaisEspeciais: false,
    //   engenhariaClinica: false,
    //   preInternacao: false,
    //   opme: false,
    //   hotelaria: false,
    //   anestesia: false,
    //   gerenciamentoLeito: false,
    //   bancoDeSangue: false,
    // },
    fazReservaDeSala: false,
    hisTipo: 'Finx',
    hospitalInsereProcedimentosDeInternacao: false,
    hospitalUtilizaRegraDeMedicoExecutante: false,
    hospitalUtilizaChat: false,
    hospitalSolicitaAlterarReservaNoMapaCirurgico: false,
    hospitalEnviaEmailParaOPacienteNaTriagem: false,
    exigeNumeroReserva: false,
    listaApenasFornecedorHomologadoParaOBackoffice: false,
    exibeAlertaDeFornecedorNaoHomologado: false,
    hospiltaTemConfiguracaoPdf: false,
    dataGoLiveIntegracaoHis: null,
    hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada: false,
    hospitalAutorizaSolicitacaoNaTriagemQuandoInformadoSenhaProvisoria: false,
    hospitalUtilizaFluxoDeRevisaoCirurgicaDeCirurgiaParticular: false,
    hospitalIncluiEquipamentoExigidoNoProcedimentoNoMedicoFinalizar: false,
    hospitalPreencheNumeroDaReserva: false,
    informaMotivoTransferenciaReserva: false,
    utilizarCaixaDeSaidaTemporaria: false,
    resolvePendenciaDeMedico: false,
    exibeOpmeDeHospitalParaOMedico: false,
    exibeFornecedorDeHospitalParaOMedico: false,
    diasParaTriagemPrioritaria: null,
    hospitalIncluiSolicitacaoParaMedicoSemLogin: false,
    permiteDesfazerCancelamento: false,
    dataAutorizacaoNaOperadoraObrigatoria: false,
    dataAutorizacaoNaOperadoraEditavel: false,
    utilizaExibicaoDeComentarioSimplificado: false,
    hospitalUtilizaCategoriaPorPlano: false,
    hospitalFazOrcamentoParticularAvulso: false,

    nomeRede: null,
    tipoCotacaoOpmeNoHis: null,
    integradorServiceEndpointKey: null,
    preencheNumeroDaReserva: null,
    diasParaBloqueioDeAlteracaoDeDataAntesDaCirurgia: null,
    convenioPrazoEmDiasParaTriagem: null,

    enviaEmailPreReserva: false,
    enviaSmsDeStatusDaAutorizacaoParaOPaciente: false,
    hospitalFazOrcamento: false,
    hospitalFazCotacaoDeOpmeAposTriagem: false,
    hospitalFazPreAgendamento: false,
    hospitalNotificaCirurgiaAutorizada: false,
    hospitalNotificaCirurgiaAutorizadaParcial: false,
    hospitalNotificaOrcamentoDeCirurgiaParticular: false,
    hospitalRealizaTriagemDuranteOPreAgendamento: false,
    hospitalTemFluxoDeEntradaDeSolicitacaoPorTipoDeUsuarioQueEnviou: false,
    hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos: false,
    hospitalAplicaRegraValorAcimaDoLimiteDoPacote: false,
    hospitalFazAnalisePosCotacao: false,
    hospitalFazDeParaDeCodificacaoDeOpme: false,
    hospitalFazPreAutorizacaoDepoisDeFazerAnalisePosCotacao: false,
    hospitalEnviaParaSuprimentosAposTriagem: false,
    hospitalUtilizaFluxoDePrecificacaoOperadora: false,
    hospitalUtilizaStatusRetornoDeCotacao: false,
    hospitalFazPreAutorizacaoDepoisDePreCotacao: false,
    hospitalUsaAreaDeSuprimentosMesmoSemCotarOpme: false,
    hospitalFazPreAutorizacaoDepoisDeFazerCotacao: false,
    hospitalBloqueiaReservaQuandoTemConflitoDeEquipamentos: false,
    hospitalAnexaImagensNoEmailDeNovaSolicitacao: false,
    hospitalUtilizaFluxoDeReservaDeMaterial: false,
    dataVirtualFazReservaDeSala: false,
    recomecaFluxoDaSolicitacaoAoDesfazerCancelamento: false,
    hospitalFazAnalisePreCotacaoNaUrgencia: false,
    enviaNotificacoes: false,
    enviaEmailDeDataConfirmadaParaOMedico: false,
    enviaEmailDeStatusDaAutorizacaoParaOMedico: false,
    enviaSMSDeStatusDaAutorizacaoParaOMedico: false,
    enviaSMSDeDataConfirmadaParaOMedico: false,
    enviaSMSDeDataConfirmadaParaOPaciente: false,
    hospitalNotificaProximasCirurgiasConfirmadas: false,
    hospitalEnviaParaSuprimentosAposTriagemNaUrgencia: false,
    desfazerCancelamentoComOpmeVoltaParaAntesDeSuprimentos: false,
    usaProcedimentoApenasHospitalDia: false,
    bloqueiaEdicaoDaPendenciaEmAutorizacao: false,
    hospitalConfiguraSalaCentroCirurgico: false,
    permiteCancelarCirurgiaRealizada: false,
    hospitalEvoluiParaAutorizadaPosAnalisePreAutorizacao: false,
    hospitalFazAnalisePreAutorizacaoAposTriagem: false,
    hospitalNaoPermiteOpcoesDatasSugeridasNoMesmoDia: false,
    hospitalEnviaParticularParaAguardandoNegociacao: false,
    hospitalEnviaParticularParaOHisNaTriagem: false,
    hospitalEnviaParticularParaOrcamentoNaRevisaoCirurgica: false,
    hospitalFazReservaDeSalaEmHospitalDaRede: false,
    hospitalEnviaParticularParaOrcamentoNaTriagem: false,
    hospitalExigeDocumentacaoDoPacienteQuandoCaraterUrgencia: false,
    hospitalPermiteAlterarMedicoSolicitante: false,
    particularVaiParaAutorizadoAposTriagem: false,
    hospitalEnviaAguardandoAutorizacaoUrgenciaDepoisDaAnalisePreAutorizacaoUrgencia: false,
    hospitalEnviaAnalisePreAutorizacaoUrgenciaDepoisDaTriagem: false,
    utilizaTipoAcomodacaoHospital: false,
    hospitalMantemSituacaoAoAlterarCarater: false,
    fidelizacaoBloqueiaPreCotacao: false,
    hospitalEnviaAlteracaoParaOHisComCirurgiaRealizada: false,
    hospitalBloqueiaAlteracaoDeReservaComCirurgiaRealizada: false,
    usaAntecedenciaNaVigenciaDaConfiguracaoDeSala: false,
    maximoDiasMedicoSemReserva: null,
    usaFluxoDeFarmacia: false,
    hospitalIntegraComAutorizadorAntesDaReserva: false,
    hospitalCancelaNaFinxMesmoComErroDeCancelamentoNoHis: false,
    hospitalPossuiTermoDeUso: false,
    hospitalUtilizaRegrasDeReservaDeSala: false,
    hospitalIntegraPais: false,
    hospitalInformaPacienteInternado: false,
    usaAnalisePreAutorizacaoNaUrgenciaComOpmeComCotacao: false,
    usaAnalisePreAutorizacaoNaUrgenciaComOpmeSemCotacao: false,
    usaAnalisePreAutorizacaoNaUrgenciaSemOpme: false,
    enviaParaAutorizacaoPosNaUrgencia: false,
    urgenciaNaTriagemEnviaParaRevisaoCirurgica: false,
    urgenciaParticularNaTriagemEnviaParaRevisaoCirurgica: false,
    usaAnalisePreAutorizacaoNaUrgenciaParticularSemOpme: false,
    usaAnalisePreAutorizacaoNaUrgenciaParticularComOpmeSemCotacao: false,
    usaAnalisePreAutorizacaoNaUrgenciaParticularComOpmeComCotacao: false,
    enviaParaAutorizacaoPosNaUrgenciaParticular: false,
    hospitalExibeCancelamentoSolicitadoNoMapaGradeCirurgica: false,
    iniciaFluxoDoPreAnestesicoNoMedicoFinaliza: false,
    tempoCirurgicoParametrizadoPadrao: null,
    hospitalInformaMotivoDeRecusaDoOrcamento: false,
    hospitalIntegradoEnviaNovaSolicitacaoParticularParaOrcamentoAposTriagem: false,
    hospitalGeraGuiaTissPeloFront: false,
    hospitalFazOrcamentoAntesDoAgendamento: false,
    hospitalUtilizaControleDePagamentoParaOrcamentoParticular: false,
    hospitalBloqueiaEdicaoAposOrcamentoAprovado: true,
    hospitalBloqueiaConvenioNaoParticularNaPendenciaDeOrcamento: false,
    gravaPrimeiroIdEquipamentoAoEscolherGrupoEquipamento: false,
    hospitalFazRevisaoCirurgicaNaAutorizacao: false,
    hospitalPermitePreInternacaoEmQualquerEtapaDoBateMapa: false,
    hospitalConfiguraDataSugeridaEmDiasUteis: false,
    hospitalRemoveParticularDaGuiaTiss: false,
    rotuloFornecedorGuiaTiss: 'Fornecedor',
    hospitalAlteraStatusAoCriarSolicitacaoDoAutorizador: false,
    hospitalValidaHisIdDoFornecedorOpme: false,
    realizaVerificacaoAutomaticaElegibilidade: false,
    horariosConsultaElegibilidadeAutomatica: null,
    hospitalUtilizaCategoriaConvenioComoFallback: false,
    hospitalOcultaAprovacaoParaMedicoESecretaria: false,
    hospitalOfertaProcedimentosViaNegociacaoComConvenio: false,
    permiteVisualizacaoGuiaTissNaVisaoClinica: false,
    hospitalAutorizaAposAprovacaoDoOrcamento: false,
    hospitalUtilizaFluxoPreCotacao: false,
    hospitalNaoAvancaNaAutorizacaoEmAnalise: false,
  }

  public hospitalConfigFlag: HospitalConfigFlag = { ...this.hospitalConfigFlagDefault }

  @Mutation
  setHospitalConfigFlag(value: HospitalConfigFlag) {
    this.hospitalConfigFlag = { ...this.hospitalConfigFlagDefault, ...value } as HospitalConfigFlag
    // @ts-ignore
    if (!['', null, undefined].includes(this.hospitalConfigFlag.dataGoLiveIntegracaoHis)) {
      this.hospitalConfigFlag.dataGoLiveIntegracaoHis = new Date(moment(this.hospitalConfigFlag.dataGoLiveIntegracaoHis, 'YYYY-MM-DDTHH:mm').toString())
    }
  }

  @Mutation
  clearHospitalConfigFlag() {
    this.hospitalConfigFlag = { ...this.hospitalConfigFlagDefault }
  }

  @Action
  async updateConfiguracaoHospital(flagsOverride?: Record<string, any>) {
    try {
      const base = flagsOverride || this.hospitalConfigFlag
      const params: any = { hospitalId: this.hospitalConfigFlag.id, ...base }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) {
          delete params[key]
        }
      })
      if (params.dataGoLiveIntegracaoHis) params.dataGoLiveIntegracaoHis = moment(params.dataGoLiveIntegracaoHis).format('YYYY-MM-DDTHH:mm:ss')

      const request = await Apis.Agendamento.SuporteApi.updateConfiguracaoHospital(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** DeFinxParaHis */
  public hospitalId: string = ''
  public search: string = ''
  private configDeFinxParaHisDefault: DeFinxParaHis[] = []
  public configDeFinxParaHis: DeFinxParaHis[] = [...this.configDeFinxParaHisDefault]
  private deFinxParaHisDefault: DeFinxParaHis = {
    id: '',
    propriedadeFinx: '',
    propriedadeHis: '',
    valorFinx: '',
    valorHis: '',
    hospitalId: '',
  }

  public deFinxParaHis: DeFinxParaHis = { ...this.deFinxParaHisDefault }

  @Mutation
  setSearch(value: string) {
    this.search = value
  }

  @Mutation
  clearSearch() {
    this.search = ''
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setConfigDeFinxParaHis(value: DeFinxParaHis[]) {
    this.configDeFinxParaHis = value
  }

  @Mutation
  clearConfigDeFinxParaHis() {
    this.configDeFinxParaHis = [...this.configDeFinxParaHisDefault]
  }

  @Mutation
  removeItemDeFinxParaHis(id: string) {
    this.configDeFinxParaHis.splice(this.configDeFinxParaHis.findIndex((item: DeFinxParaHis) => item.id === id), 1)
  }

  @Mutation
  setDeFinxParaHis(value: DeFinxParaHis) {
    this.deFinxParaHis = value
  }

  @Mutation
  clearDeFinxParaHis() {
    this.deFinxParaHis = { ...this.deFinxParaHisDefault }
  }

  @Action
  async getAllConfigDeFinxParaHisByHospital(hospitalId: string) {
    try {
      const params: any = { hospitalId, searchText: '' }
      const request = await Apis.Agendamento.SuporteApi.getAllConfigDeFinxParaHisByHospital(params)
      if (request.success && request.data && request.data.configDeFinxParaHis) this.context.commit('setConfigDeFinxParaHis', request.data.configDeFinxParaHis as DeFinxParaHis[] || [])
      return request
    } catch (error) {
      this.context.commit('setConfigDeFinxParaHis', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertDeFinxParaHis() {
    try {
      const params: any = { ...this.deFinxParaHis, hospitalId: this.hospitalId }
      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) {
          params[key] = null
          if (key === 'id') delete params[key]
        }
      })
      const request = await Apis.Agendamento.SuporteApi.upsertDeFinxParaHis(params)
      if (request.success) await this.context.dispatch('getAllConfigDeFinxParaHisByHospital', params.hospitalId)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteDeFinxParaHis() {
    try {
      const request = await Apis.Agendamento.SuporteApi.deleteDeFinxParaHis({ hospitalId: this.deFinxParaHis.hospitalId, deFinxParaHisId: this.deFinxParaHis.id })
      if (request.success) this.context.commit('removeItemDeFinxParaHis', this.deFinxParaHis.id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Propriedades Finx e His */
  propriedadesFinx: string[] = [
    'NaoEncontrato',
    'StatusSituacao',
    'TipoProcedimento',
    'Carater',
    'ReservaHemocomponentes',
    'ExamesIntraOperatorios',
    'HonorarioMedico',
    'ReservaUTI',
    'AnestesiaDoHospital',
    'AutorizacaoStatus',
    'TemCongelacao',
    'TesteCovid',
    'TemMarcapasso',
    'Reoperacao',
    'TipoDeAutorizacao',
    'NecessitaTipagemSanguinea',
    'ReservaHemocomponenteSimples',
    'TipoAcomodacao',
    'LocalAtendimentoId',
    'Opme',
    'TempoCirurgia',
    'Precaucoes',
    'AlergiaLatex',
    'MedicamentosEspeciais',
    'MedicacaoContinua',
    'EquipeMedica',
    'TecnicaDaCirurgia',
    'ObservacaoReservaSala',
    'StatusAutorizacaoDoOpmeNoAgendamento',
    'ConvenioParticular',
    'Lateralidade',
    'PrevisaoDeUsoQuimioterapico',
    'OrientacoesDePreparoDoPaciente',
    'InstrucoesParaOAgendamento',
    'TemOpme',
    'EquipamentosSemHisId',
    'StatusDoDomain',
    'PesoDoPaciente',
    'IndicacaoClinica',
    'InternacaoDeVespera',
    'TipoInternacao',
    'RegiaoDaCirurgia',
    'HonorarioAnestesista',
    'DescricaoOpmes',
    'Equipamentos',
    'TipoAnestesia',
    'RegistraProtocoloDeRecuperacaoPrecoce',
    'Cbo',
    'Cid',
    'Alergias',
    'StatusBolsaDeSangue',
    'ClassificacaoCarater',
    'PacienteEhOncologico',
  ]

  propriedadesHis: string[] = [
    'NaoEncontrato',
    'StatusDoAgendamento',
    'StatusDaAutorizacaoNoAgendamento',
    'AutorizacaoStatus',
    'TipoDeAutorizacao',
    'AutorizacaoTipoDeInternacao',
    'ReservaLeito',
    'CaraterCirurgiaHisId',
    'BolsaDeSangue',
    'Servico',
    'AnestesiaDoHospital',
    'AutorizacaoTipoGuia',
    'AutorizacaoTipoDiaria',
    'AutorizacaoResponsavel',
    'AutorizacaoSetorResponsavel',
    'AutorizacaoSetorOrigem',
    'InformacoesAdiconais',
    'TipoFormaAgendamento',
    'TipoClassificacao',
    'TipoDeAcomodacaoHisId',
    'CodigoProcedencia',
    'NecessitaTipagemSanguinea',
    'ConvenioParticular',
    'TipoDeAtendimento',
    'ClassificacaoAgendaHisId',
    'StatusAutorizacaoDoOpmeNoAgendamento',
    'StatusDoDomain',
    'TipoDeAtendimentoHisId',
    'CancelamentoHisId',
    'TemCongelacao',
    'AnestesiaHisId',
    'FuncionarioHisId',
    'ReservouHisId',
    'TipoJustificativaHisId',
    'TipoAlergiaHisId',
    'AgenteCausadorHisId',
    'ConfirmacaoAlergiaHisId',
    'AcaoAlergiaHisId',
    'IntensidadeAlergiaHisid',
    'NegaAlergiaHisId',
    'NursingProfileHisId',
    'PessoaFisicaHisIdDoUsuarioIntegrafinx',
    'ProcedimentoAutorizacao',
    'UnidadeDeInternacaoHisId',
    'TipoDeInternacaoHisId',
    'TecnicaUtilizadaHisId',
    'TipoCirurgiaHisId',
    'NecessitaCongelacao',
    'PrioridadeHisId',
    'AnestesistaHisId',
    'LateralidadeHisId',
    'NaturezaDaCirurgia',
    'TipoPagamentoHisId',
    'OpmeHisId',
    'ExameHisId',
    'TipoDoExame',
    'SetorDoExameHisId',
    'TipoPagamentoAnestesistaHisId',
    'Cbo',
    'Cid',
    'TipoAgendamento',
    'SnImpresso',
    'CodigoMultiEmpresa',
    'Contato',
    'PacienteEhOncologico',
  ]
}
